import { SUPABASE_URL } from '../../utils/supabase/url';
import { projectId, publicAnonKey } from '../../utils/supabase/info';

export const workspaceLockKey = 'quantis-workspace-locked';
let lastAccessToken: string | undefined;
let pending: Promise<void> | undefined;

export function rememberWorkspaceAccessToken(token: string | undefined) {
  if (token) lastAccessToken = token;
}

// Presentation only: server access checks remain authoritative. Using the last
// JWT directly avoids recursively triggering refresh/sign-out from this check.
export function preserveWorkspaceLock(): Promise<void> {
  if (pending) return pending;
  if (!lastAccessToken) return Promise.resolve();
  pending = (async () => {
    try {
      const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/workspace_session_blocked`, {
        method: 'POST',
        headers: { apikey: publicAnonKey, Authorization: `Bearer ${lastAccessToken}`, 'Content-Type': 'application/json' },
        body: '{}',
        signal: AbortSignal.timeout(2000),
      });
      if (response.ok && await response.json() === true) sessionStorage.setItem(workspaceLockKey, 'true');
    } catch {
      // Expired credentials or an unavailable network follow normal sign-out.
    } finally { pending = undefined; }
  })();
  return pending;
}
